//export const apiBaseUrl = 'http://local.sanlida.com/';
export const apiBaseUrl = 'https://www.sanlida.cn/';
//export const apiBaseUrl = 'http://local.sanlida.com/';

export const locationHost = process.env.NODE_ENV === 'production' ? apiBaseUrl : 'http://localhost:8080';

// 是否开启公众号扫码登录
export const showWechatLogin = true;
